export enum RouteEnum {
  STORE = '/',
  MATERIAL = '/material',
  COLOR = '/color',
  DESIGN = '/design-shape',
  ORDER_SUMMARY = '/order-summary',
}

export type RouteState = {
  currentRoute: RouteEnum;
  routeHistory: RouteEnum[];
};
